import $ from 'jquery'
import Swiper, { Navigation, Pagination } from 'swiper'
import { lockScreen, unlockScreen } from '../modules/screenLocker'
import { isSP } from '../modules/checkScreen'

const $openModal = $('.js-modal-member').find('.link')
const $closeModal = $('.js-close-popup')
const $modalOverlay = $('.js-member-modal')
const OPEN_CLASS = '-is-active'
let dragging = false
const event = 'click'

$('body').on('touchmove', () => {
  dragging = true
})

$('body').on('touchend', () => {
  // if (dragging) return
  // wasn't a drag, just a tap
  // more code here
})

$('body').on('touchstart', () => {
  dragging = false
})

// configure Swiper to use modules
Swiper.use([Navigation, Pagination])

const popupSwiper01 = new Swiper('.js-popup-swiper-gallery', {
  autoHeight: true, //enable auto height
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.popup-slider__button-next',
    prevEl: '.popup-slider__button-prev',
  },
})

const openModal = () => {
  if ($openModal.length) {
    $openModal.each((index, el) => {
      const $this = $(el)

      $this.on('click', () => {
        const $dataSlider = $this.data('image')
        $modalOverlay.addClass(OPEN_CLASS)
        lockScreen()
        popupSwiper01.slideTo($dataSlider, 500, function () {

        })
        return false
      })
    })
  }
}

const closeModal = () => {
  if ($closeModal.length) {
    $closeModal.on('click', () => {
      $modalOverlay.removeClass(OPEN_CLASS)
      unlockScreen()
      return false
    })
  }
}

const initCompany = () => {
  openModal()
  closeModal()

  $(document).on('click touchend', function (e) {
    if ($(e.target).closest('.c-popup-gallery').length === 0) {
      if (!dragging) {
        if ($modalOverlay.hasClass(OPEN_CLASS)) {
          $modalOverlay.removeClass(OPEN_CLASS)
        }
      }
    }
    unlockScreen()
  })
}

export default initCompany
